import React from "react";
import SelfieModeButton from "components/Selfie/SelfieModeButton";
import SelfieShootButton from "components/Selfie/SelfieShootButton";
import PictureModeButton from "components/Selfie/PictureModeButton";
import VideoModeButton from "components/Selfie/VideoModeButton";
import CloseButton from "components/Selfie/CloseButton";
import AvatarHideButton from "components/Selfie/AvatarHideButton";
import SaveCloseButton from "components/Selfie/SaveCloseButton";
import SwitchHandButton from "components/Selfie/SwitchHandButton";
import "./index.scss";

const View = props => {
  return (
    <div>
      {!props.selfie.isActivated && (
        <SelfieModeButton onClick={props.onClickSelfieModeBtn} />
      )}
      {props.selfie.isActivated &&
        !props.selfie.isSavingPhoto &&
        !props.selfie.isSavingVideo && (
          <div className="top-menu">
            <div
              className={`center-menu ${props.isIPXMode && "ipx_center_menu"}`}
            >
              <div className="selfie-menu-container">
                <SelfieShootButton onClick={props.onClickSelfieShootBtn} />
                <PictureModeButton
                  onClick={props.onClickPictureBtn}
                  borderRadius={props.onClickSwitchBtn}
                />
                {/* <VideoModeButton onClick={props.onClickVideoBtn} /> */}
              </div>
              {!props.isIPXMode && (
                <SwitchHandButton onClick={props.onClickSwitchBtn} />
              )}
            </div>
            <div className="right-menu">
              {!props.isIPXMode && (
                <AvatarHideButton onClick={props.onClickAvatarHideBtn} />
              )}

              {/* GUI 표시 버튼 */}
              <CloseButton onClick={props.onClickCloseBtn} />
            </div>

            {/* IPX 모드일때만 노출 */}
            {props.isIPXMode && (
              <div className="ipx_top_avatar_btn">
                <SwitchHandButton onClick={props.onClickSwitchBtn} />
                <AvatarHideButton onClick={props.onClickAvatarHideBtn} />
              </div>
            )}
          </div>
        )}
      {props.selfie.isActivated &&
        (props.selfie.isSavingPhoto || props.selfie.isSavingVideo) && (
          <SaveCloseButton onClick={props.onClickSaveCloseBtn} />
        )}
    </div>
  );
};

export default View;
